import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";

const Span = styled.span`
  display: block;
  margin-top: 4px;
  color: #d11609;
  font-size: ${fontSize.xxs};
`;

function InputError({ error }) {
  return <Span>{error}</Span>;
}

export default InputError;
